import { Transfer } from '#/api/transfers';

/**
 * Check whether the transfer is internal to Paradex.
 */
export function isInternal(transfer: Transfer): boolean {
  return transfer.bridge === '';
}
